import BaseService from './BaseService';
import Environment from './Environment';

export default class DataRetrievalService extends BaseService {
  constructor() {
    super();
  }
  public get() {
    this.endpoint = Environment.getEnvironment();
    return super.get();
  }
}
